import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "mentor_add_entry"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "メンター追加情報登録", -1);
const _hoisted_5 = { class: "inner" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode("メンター審査にて承認されたため、追加情報の登録をお願い致します。"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode("後でメニューから変更することもできます。")
], -1);
const _hoisted_7 = ["onSubmit"];
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 振込先"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "non_public" }, "非公開")
], -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "金融機関コード", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", null, "（半角数字4桁）", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_12 = {
    key: 0,
    class: "err"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "金融機関名", -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_15 = {
    key: 1,
    class: "err"
};
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "支店コード", -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("span", null, "（半角数字3桁）", -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_19 = {
    key: 2,
    class: "err"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "支店名", -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_22 = {
    key: 3,
    class: "err"
};
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "種別", -1);
const _hoisted_24 = ["value"];
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", { for: "q2_5_a1" }, "普通", -1);
const _hoisted_26 = ["value"];
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", { for: "q2_5_a2" }, "当座", -1);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_29 = {
    key: 4,
    class: "err"
};
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "口座名義", -1);
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("span", null, "（半角ｶﾅ）", -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_33 = {
    key: 5,
    class: "err"
};
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "口座番号", -1);
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("span", null, "（半角数字7桁）", -1);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("span", null, "6桁の口座をお持ちの方は左に0を追加して7桁でご入力ください。", -1);
const _hoisted_38 = {
    key: 6,
    class: "err"
};
const _hoisted_39 = { class: "bt_box" };
const _hoisted_40 = { class: "err_list" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("ul", null, [
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("button", {
            type: "submit",
            id: "submit-button",
            value: "登録"
        }, "登録")
    ])
], -1);
import { watch, onUnmounted } from 'vue';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import { AccountType } from '@util/Consts';
export default /*#__PURE__*/ _defineComponent({
    __name: 'mentor_add_entry',
    props: {
        common: null,
        errors: null
    },
    setup(__props) {
        const props = __props;
        const form = InertiaUtil.getForm({
            // receive_rewards: true,
            bank_code: '',
            institution_name: '',
            branch_code: '',
            branch_name: '',
            account_type: AccountType.USUALLY,
            account_holder: '',
            account_number: '',
        });
        watch(() => form.bank_code, () => {
            const pattern = /[^0-9]/g;
            form.bank_code = form.bank_code.replace(pattern, '');
        });
        watch(() => form.branch_code, () => {
            const pattern = /[^0-9]/g;
            form.branch_code = form.branch_code.replace(pattern, '');
        });
        watch(() => form.account_number, () => {
            const pattern = /[^0-9]/g;
            form.account_number = form.account_number.replace(pattern, '');
        });
        // 文字数チェック
        watch(() => form.institution_name, (value) => {
            if (Alert.charLimitText(value)) {
                form.institution_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.branch_name, (value) => {
            if (Alert.charLimitText(value)) {
                form.branch_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.account_holder, (value) => {
            if (Alert.charLimitText(value)) {
                form.account_holder = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.account_number, (value) => {
            if (Alert.charLimitText(value)) {
                form.account_number = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => form, () => PageExitConfirm.addEvent(), { deep: true });
        const onSubmit = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('mentor.register.additional.store'));
        };
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSubmit, ["prevent"])
                                }, [
                                    _createElementVNode("dl", null, [
                                        _hoisted_8,
                                        _createElementVNode("dd", null, [
                                            _hoisted_9,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).bank_code) = $event)),
                                                type: "text",
                                                name: "q2_1",
                                                class: "w20 inquiry-form",
                                                maxlength: "4"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).bank_code]
                                            ]),
                                            _hoisted_10,
                                            _hoisted_11,
                                            ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.bank_code)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(props.errors.bank_code), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_13,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).institution_name) = $event)),
                                                type: "text",
                                                name: "q2_2",
                                                class: "w60 inquiry-form",
                                                placeholder: "例：みずほ銀行"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).institution_name]
                                            ]),
                                            _hoisted_14,
                                            ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.institution_name)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(props.errors.institution_name), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_16,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).branch_code) = $event)),
                                                type: "text",
                                                name: "q2_3",
                                                class: "w20 inquiry-form",
                                                maxlength: "3"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).branch_code]
                                            ]),
                                            _hoisted_17,
                                            _hoisted_18,
                                            ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.branch_code)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(props.errors.branch_code), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_20,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).branch_name) = $event)),
                                                type: "text",
                                                name: "q2_4",
                                                class: "f_corp wmax inquiry-form",
                                                placeholder: "例：品川支店"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).branch_name]
                                            ]),
                                            _hoisted_21,
                                            ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.branch_name)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(props.errors.branch_name), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_23,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).account_type) = $event)),
                                                value: _unref(AccountType).USUALLY,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q2_5",
                                                id: "q2_5_a1"
                                            }, null, 8, _hoisted_24), [
                                                [_vModelRadio, _unref(form).account_type]
                                            ]),
                                            _hoisted_25,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).account_type) = $event)),
                                                value: _unref(AccountType).CURRENT,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q2_5",
                                                id: "q2_5_a2"
                                            }, null, 8, _hoisted_26), [
                                                [_vModelRadio, _unref(form).account_type]
                                            ]),
                                            _hoisted_27,
                                            _hoisted_28,
                                            ((_e = props.errors) === null || _e === void 0 ? void 0 : _e.account_type)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(props.errors.account_type), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_30,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(form).account_holder) = $event)),
                                                type: "text",
                                                name: "q2_7",
                                                class: "f_corp wmax inquiry-form",
                                                placeholder: "例：ﾔﾏﾀﾞ ﾀﾛｳ"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).account_holder]
                                            ]),
                                            _hoisted_31,
                                            _hoisted_32,
                                            ((_f = props.errors) === null || _f === void 0 ? void 0 : _f.account_holder)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(props.errors.account_holder), 1))
                                                : _createCommentVNode("", true),
                                            _hoisted_34,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(form).account_number) = $event)),
                                                type: "text",
                                                name: "q2_8",
                                                class: "f_corp w40 inquiry-form",
                                                placeholder: "例：0000000",
                                                maxlength: "7"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).account_number]
                                            ]),
                                            _hoisted_35,
                                            _hoisted_36,
                                            _hoisted_37,
                                            ((_g = props.errors) === null || _g === void 0 ? void 0 : _g.account_number)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(props.errors.account_number), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("div", _hoisted_40, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                                return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                            }), 256))
                                        ]),
                                        _hoisted_41
                                    ])
                                ], 40, _hoisted_7)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
